openMenu = () => {
  elNavToggle.classList.toggle("active");
  elOverlay.classList.toggle("open");
}

collapseProducts = () => {
  elNavProdToCollapse.classList.toggle("collapsed");
}

elNavToggle = document.querySelector('#mobile-navbar-toggle');
elOverlay = document.querySelector("#mobile-navbar-overlay");

elNavProdToCollapse = document.querySelector("#navbar-prod-collapse");
elNavProdCollapseTrigger = document.querySelector("#collapse-products");

elNavToggle.addEventListener("click", openMenu);
elNavProdCollapseTrigger.addEventListener("click", collapseProducts);
